import { PerformanceLongAnimationFrameTiming } from '../types';

export function isPerformanceLongAnimationFrameTiming(
    entry: PerformanceEntry
): entry is PerformanceLongAnimationFrameTiming {
    return entry.entryType === 'long-animation-frame';
}
